import React, { useState, useEffect } from "react";
import "./FloatingActions.css";

export default function FloatingActions({ whatsappNumber }) {
  const [showTop, setShowTop] = useState(false);

  // Scroll listener for "Back to Top" button
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowTop(true);
      } else {
        setShowTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* WhatsApp Icon */}
      <a
        href={`https://wa.me/${+919600240110}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>

      {/* Back to Top Button */}
      {showTop && (
        <button className="back-to-top" onClick={scrollToTop}>
          ↑
        </button>
      )}
    </>
  );
}
